import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { newReservationEmailCreation } from "./ReservationEmailAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllReservationEmail } from "./ReservationEmailAction";
import { FaArrowLeft } from 'react-icons/fa';

const initialState = {
    email: "",
    status: "",

}

/* username: "Kavya",
contactno: "1234567890",
email: "kavya@royalarabian.com",
role_id: 1,
password: "asdf1233D@",
confirmPassword: "asdf1233D@",
address: "Mangalore",
address2: "Mangalore",
user_status: 1, */



const CreateReservationEmail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ReservationEmailRef = useRef(null);
  const [status,setStatus]= useState('');
  const [email, setNewReservationEmail] = useState('');
  const [alertStatus, setAlertStatus] = useState('');
  const [emailError, setEmailError] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();
 
  const { stiscLoading, stcstatus, stcmessage} = useSelector((state) => state.reservationEmailsList);
  
  useEffect(() => {
    dispatch(getAllReservationEmail());
   
}, [dispatch,stcmessage]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
  
    if (!email.includes('@')) {
      Swal.fire({
        title: 'Error!',
        text: 'Invalid email address',
        icon: 'error',
        confirmButtonText: 'Okay'
      });
      return;
    }
  
    const newReservationEmailCreation1 = {
      email,
      status
    };
  
    dispatch(newReservationEmailCreation(newReservationEmailCreation1));
  
    Swal.fire({
      title: 'Success!',
      text: 'Reservation Email Created Successfully',
      icon: 'success',
      confirmButtonText: 'Okay'
    });
  
    navigate('/reservationEmailList');
  
    e.target.reset();
  };
  
  const OnNewReservationEmail = (e) => {
    setNewReservationEmail(e.target.value);
    if (e.target.name === "email") {
      if (e.target.value.includes("@")) {
        setEmailError(false);
      } else {
        setEmailError(true);
      }
    }
  }
 
  const canSave = Boolean (email) && Boolean(status)
  
  return (
    <>
      
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New Reservation Email</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/reservationEmailList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridReservationEmail">
                  <Form.Label>Reservation Email</Form.Label>
                  <Form.Control type="email" ref={ReservationEmailRef}  name="email" required="true" autoComplete='off' placeholder="Enter Reservation Email"  isInvalid={emailError} {...register("email", { required: true, mixLength: 3 })} onChange={(e) => OnNewReservationEmail(e)}/>
                  {errors.email && <p className='text-danger'> Reservation Email required</p>}
                  {emailError && (
                    <Form.Control.Feedback type="invalid">
                      Email should contain the "@" symbol.
                    </Form.Control.Feedback>
                  )}
                </Form.Group>   
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" {...register("status" , { required: true })} onChange={(e) => setStatus(e.target.value)}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle' disabled={!canSave}>
              <FontAwesomeIcon icon={faRightToBracket} /> Submit
              </Button>
              </div>
              {stiscLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
         
    </>
  );
}

export default CreateReservationEmail;